export const classes = {
  listItem:
    'w-full place-between gap-4 py-2 px-3 mb-2 bg-grey-2 dark:bg-white/[0.06] rounded-xl cursor-pointer border border-grey-2 dark:border-white/10 shadow-none hover:shadow-card transition-all',
  active: 'border border-orange-2',
  wrapper: 'place-start gap-4',
  content: 'flex flex-col',
  fieldType: 'text-xs text-grey-8 dark:text-mauve-1 font-normal',
  fieldLabel: 'text-sm text-grey-9 dark:text-mauve-1 font-medium tracking-wide',
  removeIcon:
    'remove-icon text-grey-6 dark:text-mauve-3 hover:text-grey-7 dark:hover:text-mauve-2 cursor-pointer transition-colors',
};

export const styles = {
  listItem: {
    '& .remove-icon': {
      opacity: 0,
      transition: 'opacity 0.1s',
    },
    '&:hover .remove-icon': {
      opacity: 1,
    },
  },
};
